import TwoColumnLayout from "../Layout/TwoColumnLayout";
import Hero from "../Layout/Hero";
import FormController from "../Layout/FormController";
import FormScheffler from "../Forms/FormScheffler";

function PageScheffler(props){
    return <div>
        <TwoColumnLayout>
            <Hero
                backgroundDesktop={"/Scheffler/Scheffler.png"}
                backgroundMobile={"/Scheffler/Scheffler-mobile.png"}
            ></Hero>
            <FormController
                devMode={process.env.NODE_ENV === "development"}
                formName={"scheffler"}
                form={FormScheffler}
                formHeader={<>
                    <h1 className={"text-3xl text-white font-form"}>Cadillac Iconic Experiences:<br/>Play 18 with Scottie Scheffler</h1>
                    <p className={"text-white mb-4 mt-2"}>One winner and two friends will win an all-expense paid trip to PGA Frisco to play Fields Ranch with Scottie Scheffler. Prize includes: airfare, hotel, VIP lunch, a round of golf, a tour of the Home of the PGA of America & more.</p>
                </>}
                disclaimerText={<>
                    <p>lorem ipsum and stuff</p>
                </>}
            ></FormController>
        </TwoColumnLayout>
    </div>
}

export default PageScheffler;
